export const getApiErrorMessage = (error, fallback = 'Something went wrong') => {
  const detail = error?.response?.data?.detail;

  if (typeof detail === 'string') return detail;

  if (Array.isArray(detail)) {
    const first = detail[0];
    if (typeof first === 'string') return first;
    if (first && typeof first === 'object') {
      return first.message || first.msg || fallback;
    }
    return fallback;
  }

  if (detail && typeof detail === 'object') {
    return detail.message || detail.msg || fallback;
  }

  const message = error?.response?.data?.message;
  if (typeof message === 'string' && message.trim()) return message;

  const code = error?.response?.data?.code;
  if (typeof code === 'string' && code.trim()) return code;

  return fallback;
};
